import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from '@/node_modules/vuex-module-decorators'
import {
  FirstTransitionToBibliographyDetail,
  SecondAfterTransitionToBibliographyDetail
} from '@/store/BibliographyDetailStore'
import { dataStore } from '@/utils/store-accessor'

@Module({
  name: 'ModalBibliographyDetailStore',
  namespaced: true,
  stateFactory: true
})

// 資料照会の物理・集合共用で遷移に関するフラグを管理しているstore
// 現状は他画面への遷移に関するボタンの表示制御を行っている（ペジネーション）
// あくまで共通化できる条件式をまとめているだけなので、それぞれのコンポーネント側で表示条件を追加している場合もある
// 条件式については確認をしておくように
export default class ModalBibliographyDetailStore extends BaseStore {
  // 最初に資料照会を開いた時、どこから照会に遷移したか判定する変数
  _firstTransitionSource: FirstTransitionToBibliographyDetail =
    FirstTransitionToBibliographyDetail.Not

  // 二回目以降、資料照会を開いた時、どこから照会に遷移したか判定する変数
  _secondAfterTransitionSource: SecondAfterTransitionToBibliographyDetail =
    SecondAfterTransitionToBibliographyDetail.Not

  // 初期選択とする資料の資料番号
  // ダイアログの場合はダイアログ表示を制御しているstoreで管理する事も可能
  // しかし、ページ側と初期選択処理の仕組みを同じようにしておいた方が今後の修正がしやすい、また、storeであれば外部からの書き換えも容易であると考え設定
  _initialSelectCollectionNo: string = ''

  // 除籍表示スイッチの値
  _isDisplayRemoved: boolean = false

  get firstTransitionSource(): FirstTransitionToBibliographyDetail {
    return this._firstTransitionSource
  }

  get secondAfterTransitionSource(): SecondAfterTransitionToBibliographyDetail {
    return this._secondAfterTransitionSource
  }

  // ペジネーション表示判定
  get showPagination(): boolean {
    return (
      ([
        FirstTransitionToBibliographyDetail.SearchResult,
        FirstTransitionToBibliographyDetail.Search
      ].includes(this.firstTransitionSource) ||
        [
          SecondAfterTransitionToBibliographyDetail.VolumePagination,
          SecondAfterTransitionToBibliographyDetail.Set
        ].includes(this.secondAfterTransitionSource)) &&
      ![
        SecondAfterTransitionToBibliographyDetail.Copy,
        SecondAfterTransitionToBibliographyDetail.ParentCollectionId,
        SecondAfterTransitionToBibliographyDetail.ChildCollectionList
      ].includes(this.secondAfterTransitionSource)
    )
  }

  get initialSelectCollectionNo(): string {
    return this._initialSelectCollectionNo
  }

  get isDisplayRemoved(): boolean {
    return this._isDisplayRemoved
  }

  @Mutation
  public setFirstTransitionSource(value: FirstTransitionToBibliographyDetail) {
    // フラグ変数を初期化する
    this._secondAfterTransitionSource =
      SecondAfterTransitionToBibliographyDetail.Not

    this._firstTransitionSource = value
  }

  @Mutation
  public setSecondAfterTransitionSource(
    value: SecondAfterTransitionToBibliographyDetail
  ) {
    this._secondAfterTransitionSource = value
  }

  @Mutation
  public setInitialSelectCollectionNo(value: string) {
    this._initialSelectCollectionNo = value
  }

  @Mutation
  public setIsDisplayRemoved(value: boolean) {
    this._isDisplayRemoved = value
  }

  // 全削除
  @Mutation
  public reset() {
    this._firstTransitionSource = FirstTransitionToBibliographyDetail.Not
    this._secondAfterTransitionSource =
      SecondAfterTransitionToBibliographyDetail.Not
    this._initialSelectCollectionNo = ''
    this._isDisplayRemoved =
      dataStore.bibliographyDetailPageDisplayRemovedSwitchDefaultValue
  }
}
